module.exports = __webpack_public_path__ + "img/icon_rightarrow.753efa36.svg";